import { AxiosPromise } from 'axios';
import request from '../network';

// 获取路由
export function getRoutersApi(): AxiosPromise<any[]> {
  return request({
    url: '/system/menu/getReactRouters',
    method: 'get',
  });
}
